import {
  RestrictionTypeList,
  RestrictionTypeListId
} from '../../models/restrictionTypeList.model'
import { PercentTypeList } from '../../models/percentTypeList.model'
import { SignedList } from '../../models/signedList.model'
import { EnvironmentDataAuxList } from '../../models/environmentDataAuxList.model'
import { axios } from 'src/api'
import { ChannelAuxList } from '../../models/channelAuxList.model'
import { List } from '../../models/apiTypes.model'
import { RateAuxList } from '../../models/rateAuxList.model'
import { RoomTypeAuxList } from '../../models/roomTypeAuxList.model'
import { RoomTypeCapacityAuxList } from '../../models/roomTypeCapacityAuxList.model'
import { ZoneAuxList } from '../../models/zoneAuxList.model'
import { HotelAuxList } from '../../models/hotelAuxList.model'
import { HotelDataList } from '../../models/dataList.model'
export interface ApiGetSeasonManualDataPostData {
  userToken: string
  environmentDataId?: string
  iniDate?: string
  endDate?: string
  filterVisibilityId?: string
  roomTypeList?: string[]
  rateList?: string[]
  allChannels?: boolean
  hotelList?: string[]
  roomTypeCapacityList?: string[]
}
export interface ApiGetSeasonManualParams {
  serverPath: string
  data: ApiGetSeasonManualDataPostData
  controller?: AbortController
}

export interface RestrictionEditableList {
  editable: boolean
  restrictionId: RestrictionTypeListId
}

export interface RestrictionEditableByChannelList {
  channelId: string
  restrictionEditableList: RestrictionEditableList[]
}

export interface ApiGetSeasonManualResponse {
  type: string
  errorList: any[]
  ok: boolean
  status: string
  statusType: string
  channelAuxList?: ChannelAuxList[]
  environmentDataAuxList: EnvironmentDataAuxList[]
  hotelAuxList?: HotelAuxList[]
  hotelDataList: HotelDataList[]
  percentTypeList: PercentTypeList[]
  rateAuxList?: RateAuxList[]
  roomTypeAuxList?: RoomTypeAuxList[]
  roomTypeCapacityAuxList?: RoomTypeCapacityAuxList[]
  signedList: SignedList[]
  zoneAuxList?: ZoneAuxList[]
  restrictionTypeList: RestrictionTypeList[]
  filterList: List[]
  restrictionEditableByChannelList: RestrictionEditableByChannelList[]
  restrictionTypeListToShowCapacity: (RestrictionTypeList & {
    showCapacity: boolean
  })[]
}

export const apiGetSeasonManualData = async ({
  serverPath,
  data,
  controller
}: ApiGetSeasonManualParams) => {
  const postData: ApiGetSeasonManualDataPostData = data
  return await axios.post<ApiGetSeasonManualResponse>(
    `https://${serverPath}/sialdPMS/web/resourcescrossorigin/seasonmanual`,
    postData,
    {
      signal: controller?.signal
    }
  )
}
